<!-- Desktop: centred row between logo and buttons. Below xl: the burger
     panel, with the login buttons at the end as on bildigsnetz.ch. -->
<nav
  class="navigation"
  id="menu"
  role="menu"
  aria-labelledby="menu-button"
  [ngClass]="{ 'navigation--open': isOpen }">
  <ul class="menu">
    <li class="menu__item">
      <a
        class="menu__item__link"
        routerLink="/jobs"
        routerLinkActive="menu__item__link--active"
        (click)="handleClick()">
        {{ 'publicNav.jobs' | translate }}
      </a>
    </li>
    <li class="menu__item">
      <a
        class="menu__item__link"
        routerLink="/schools"
        routerLinkActive="menu__item__link--active"
        (click)="handleClick()">
        {{ 'publicNav.schools' | translate }}
      </a>
    </li>
    <li class="menu__item">
      <a
        class="menu__item__link"
        [href]="url + 'stellenchats'"
        (click)="handleClick()">
        {{ 'publicNav.jobChats' | translate }}
        <span
          class="badge bg-light-success text-light-on-navy font-bold xl:hidden"
          >{{ 'publicNav.new' | translate }}</span
        >
      </a>
    </li>
    <li class="menu__item">
      <a
        class="menu__item__link"
        [href]="url + 'angebot'"
        (click)="handleClick()">
        {{ 'publicNav.offer' | translate }}
      </a>
    </li>
    <li class="menu__item">
      <a class="menu__item__link" [href]="url + 'news'" (click)="handleClick()">
        {{ 'publicNav.news' | translate }}
      </a>
    </li>
  </ul>
  <hr class="divider" />
  <ul class="menu menu--meta">
    <li class="menu__item">
      <a
        class="menu__item__link"
        [href]="url + 'fur-fachkrafte'"
        (click)="handleClick()">
        {{ 'publicNav.forProfessionals' | translate }}
      </a>
    </li>
    <li class="menu__item">
      <a class="menu__item__link" [href]="url + 'team'" (click)="handleClick()">
        {{ 'publicNav.about' | translate }}
      </a>
    </li>
    <li class="menu__item">
      <a
        class="menu__item__link"
        [href]="url + 'kontakt'"
        (click)="handleClick()">
        {{ 'publicNav.contact' | translate }}
      </a>
    </li>
  </ul>
  <div class="actions">
    <a class="actions__login" routerLink="/login" (click)="handleClick()">
      {{ 'publicNav.login' | translate }}
    </a>
    <a class="actions__signup" routerLink="/signup" (click)="handleClick()">
      {{ 'publicNav.signup' | translate }}
    </a>
  </div>
</nav>
